import { TuiButton } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkflowLogoutGuardService } from '@core/services/workflow/workflow-logout-guard.service';

@Component({
  selector: 'x-person-required',
  imports: [TuiButton, TranslatePipe],
  templateUrl: './person-required.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonRequiredComponent {
  private readonly workflowLogoutGuard = inject(WorkflowLogoutGuardService);

  logout(): void {
    void this.workflowLogoutGuard.logout();
  }
}
